import { combineReducers } from "redux";
import photoReducer from "./slice/images/images.slice.js";
import eventsReducer from "./slice/events/events.slice.js";
import authReducer from "./slice/auth/auth.saga.js";

export const rootReducer  = combineReducers({
    photos: photoReducer,
    events: eventsReducer,
    auth: authReducer
})

